import { useImperativeHandle } from 'react';
export default function useCalendarRef(calendarRef, _ref) {
  var navigate = _ref.navigate;
  useImperativeHandle(calendarRef, function () {
    return {
      navigate: navigate
    };
  }, [navigate]);
}